<template>
  <div>
    <div class="flex mb-4 justify-between">
      <div class="flex-grow">
        <h4 class="mb-4" v-if="language == 'en'">Assessment Summary</h4>
        <h4 class="mb-4" v-else>评估总结</h4>
      </div>
    </div>

    <div class="flex mb-4 justify-between">
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language == 'en'">Assessment ID</h5>
        <h5 class="mb-2" v-else>评估者ID编号</h5>
        <p>{{assessment.id}}</p>
      </div>
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language == 'en'">Created At</h5>
        <h5 class="mb-2" v-else>创建时间</h5>
        <p>{{(assessment.created_at).split('T').join(' ').split('.')[0]}}</p>
      </div>
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language == 'en'">Updated At</h5>
        <h5 class="mb-2" v-else>更新时间</h5>
        <p>{{(assessment.updated_at).split('T').join(' ').split('.')[0]}}</p>
      </div>
    </div>
    <div class="flex mb-4 justify-between">
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language =='en'">Age</h5>
        <h5 class="mb-2" v-else>年龄</h5>
        <p>{{assessment.age}}</p>
      </div>
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language =='en'">Gender</h5>
        <h5 class="mb-2" v-else>性别</h5>
        <p>{{assessment.gender}}</p>
      </div>
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language =='en'">Height</h5>
        <h5 class="mb-2" v-else>身高</h5>
        <p>{{assessment.height}} cm</p>
      </div>
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language =='en'">Weight</h5>
        <h5 class="mb-2" v-else>体重</h5>
        <p>{{assessment.weight}} kg</p>
      </div>
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language =='en'">Smoker</h5>
        <h5 class="mb-2" v-else>是否吸烟</h5>
        <p v-if="language =='en'">{{assessment.smoker ? "Yes" : "No"}}</p>
        <p v-else>{{assessment.smoker ? "是" : "否"}}</p>
      </div>
    </div>

    <div class="flex mb-4 justify-between">
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language =='en'">Factors</h5>
        <h5 class="mb-2" v-else>你具有下列哪些生活方式因素</h5>
        <p
          v-for="(factor, index) in assessment.factors"
          :key="index"
        >{{language == 'en' ? factor.name : factor.name_zh}}</p>
      </div>
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language =='en'">Other Medication Taken</h5>
        <h5 class="mb-2" v-else>其他正在使用的药物</h5>
        <p>{{assessment.medications}}</p>
      </div>
    </div>

    <div
      v-for="(syndromeQuestionnaireObject, index) in assessment.syndromeQuestionnaireObjects"
      :key="index"
    >
      <div class="mb-4">
        <h4 class="mb-4" v-if="language =='en'">{{syndromeQuestionnaireObject.syndrome.name}}</h4>
        <h4 class="mb-4" v-else>{{syndromeQuestionnaireObject.syndrome.name_zh}}</h4>
      </div>

      <div class="flex flex-col flex-wrap mb-4 justify-between">
        <div
          v-for="(questionnaire, index) in syndromeQuestionnaireObject.questionnaires"
          :key="index"
          class="flex-grow text-left"
        >
          <h6 class="mb-2" v-if="language =='en'">{{questionnaire.questionnaire_section.title}}</h6>
          <h6 class="mb-2" v-else>{{questionnaire.questionnaire_section.title_zh}}</h6>
          <p>{{questionnaire.result}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["assessment", "language"]
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .flex {
    display: block;
  }
}
</style>